import { XrefNumber } from './../models/xref-number.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseResponse, BaseResponseObj } from 'ccc-commons/dist/core';

@Injectable()
export class XrefService {

  orgUrl = environment.apiUrl + '/organizations';
  xrefUrl = environment.apiUrl + '/xreferences';

  constructor(private http: HttpClient) { }

  getXrefNumbers(orgId): Observable<BaseResponse<XrefNumber>> {
    return this.http.get<BaseResponse<XrefNumber>>(
      this.orgUrl + `/${orgId}` + '/xreferences'
    );
  }

  addXref(xref: XrefNumber): Observable<BaseResponseObj<XrefNumber>> {
    return this.http.post<BaseResponseObj<XrefNumber>>(
      this.orgUrl + `/${xref.organizationId}` + '/xreferences',
      xref
    );
  }
  updateXref(xref: XrefNumber): Observable<BaseResponseObj<XrefNumber>> {
    return this.http.put<BaseResponseObj<XrefNumber>>(
      this.xrefUrl + `/${xref.id}`,
      xref
    );
  }

  deleteXref(xrefId) {
    return this.http.delete<BaseResponseObj<XrefNumber>>(
      this.xrefUrl + `/${xrefId}`);
  }

  uploadXrefCvsFile(orgId, file: File): Observable<BaseResponseObj<XrefNumber>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<BaseResponseObj<XrefNumber>>(`${this.orgUrl}/${orgId}/xreferences/import`, formData);
  }

  downloadCsvTemplate(orgId): Observable<BaseResponseObj<any>> {
    return this.http.get(`${this.orgUrl}/${orgId}/xreferences/template`, {responseType: 'blob', observe: 'response'});
  }

  downloadXrefCvsFile(orgId): Observable<BaseResponseObj<any>> {
    return this.http.get(`${this.orgUrl}/${orgId}/xreferences/export`, {responseType: 'blob', observe: 'response'});
  }
}
